import { frameworkBanner } from "../../../core/components/banner/configuration/bannerconfiguration";
import { introAssetConfig } from "../../../data/intro";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";


frameworkBanner.data = {
    "BANNER_CONTAINER_X": 0,
    "BANNER_CONTAINER_Y": 0,
    "COMPONENTS": [
        {
            "id": "gameBannerOutro",
            "name": "gameBannerContainerOutro",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "group": "Outro",
            "visible": false,
            "parentLayer": "baseLayer",
            child: [
                {
                    "id": "gameBannerComponentOutro",
                    "name": "GameBanner",
                    "type": "Tag",
                    "class": "",
                    "group": "Outro",
                    "filterTypes": [],
                    child: [
                        {
                            "name": "introGraphic",
                            "type": "Graphic",
                            "shape": "rectangle",
                            "visible": true,
                            "alpha": 0.94,
                            "group": "Outro",
                            "color": "0x000000",
                            "x": 0,
                            "y": 0,
                            "width": 1920,
                            "height": 1080,
                        },
                        {
                            "name": "outroBg_desktop",
                            "image": "introBG",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "interactive": false,
                            "buttonMode": false,
                            "group": "Outro",
                            "width": 1078,
                            "height": 921,
                            "anchor": [0.5, 0.5],
                            "x": 940,
                            "y": 520,
                        },
                        {
                            "name": "outroBg_mobile",
                            "image": "introBG",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "interactive": false,
                            "buttonMode": false,
                            "group": "Outro",
                            "width": 1078,
                            "height": 921,
                            "anchor": [0.5, 0.5],
                            "x": 940,
                            "y": 520,
                        },

                        {
                            "id": "fg_outro_Congratulation_desktop",
                            "name": "fg_outro_Congratulation_desktop",
                            "type": "Text",
                            "x": 940,
                            "y": 340,
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "text": "congrats",
                            "width": 2440,
                            "height": 600,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 105,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                letterSpacing: 5,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },

                        {
                            "id": "fg_outro_Congratulation_mobile",
                            "name": "fg_outro_Congratulation_mobile",
                            "type": "Text",
                            "x": 940,
                            "y": 340,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "text": "congrats",
                            "width": 2440,
                            "height": 600,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 105,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                letterSpacing: 5,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },
                        {

                            "id": "text_1_OutroScreenFG_desktop",
                            "name": "text_1_OutroScreenFG_desktop",
                            "type": "Text",
                            "x": 955,
                            "y": 450,
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "text": "youwon",
                            "width": 1200,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 80,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                letterSpacing: 3,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },



                        {

                            "id": "text_1_OutroScreenFG_desktop_mobile",
                            "name": "text_1_OutroScreenFG_desktop_mobile",
                            "type": "Text",
                            "x": 955,
                            "y": 450,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "text": "youwon",
                            "width": 1200,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 80,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                letterSpacing: 3,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },

                        {

                            "id": "text_3_OutroScreenFG_desktop",
                            "name": "text_3_OutroScreenFG_desktop",
                            "type": "Text",
                            "x": 955,
                            "y": 600,
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "text": "$4000.00",
                            "width": 800,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 100,
                                fontStyle: 'bold',
                                fill: ['#ffffff', '#ededed'],
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },

                        {

                            "id": "text_3_OutroScreenFG_mobile",
                            "name": "text_3_OutroScreenFG_mobile",
                            "type": "Text",
                            "x": 955,
                            "y": 600,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "text": "$4000.00",
                            "width": 800,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 100,
                                fontStyle: 'bold',
                                fill: ['#ffffff', '#ededed'],
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },
                    ]
                }
            ]

        },
        {
            "id": "gameBannerIntro",
            "name": "gameBannerContainerIntro",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "group": "Intro",
            "parentLayer": "baseLayer",
            child: [


                {
                    "id": "gameBannerComponentIntro",
                    "name": "GameBanner",
                    "type": "Tag",
                    "class": "",
                    "group": "Intro",
                    "filterTypes": [],
                    child: [
                        {
                            "name": "introGraphic",
                            "type": "Graphic",
                            "shape": "rectangle",
                            "visible": true,

                            "alpha": 0.94,
                            "group": "Intro",
                            "color": "0x000000",
                            "x": 0,
                            "y": 0,
                            "width": 1920,
                            "height": 1080,
                        },

                        {
                            "name": "introBg_desktop",
                            "image": "introBG",
                            "type": "Image",
                            "class": "",
                            "layout": false,
                            "uimode": "desktop",
                            "visible": true,
                            "interactive": false,
                            "buttonMode": false,
                            "group": "Intro",
                            "width": 1078,
                            "height": 921,
                            "anchor": [0.5, 0.5],
                            "x": 940,
                            "y": 520,
                        },
                        {
                            "id": "fg_intro_Congratulation",
                            "name": "fg_intro_Congratulation_desktop",
                            "type": "Text",
                            "x": 940,
                            "y": 340,
                            "visible": true,
                            "layout": false,
                            "uimode": "desktop",
                            "text": "congrats",
                            "width": 2440,
                            "height": 600,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 105,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                letterSpacing: 5,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 4,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },


                        {
                            "id": "fg_intro_count",
                            "name": "fg_intro_count_desktop",
                            "type": "Text",
                            "x": 955,
                            "y": 610,
                            "visible": true,
                            "layout": false,
                            "uimode": "desktop",
                            "text": "10",
                            "width": 1200,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 200,
                                fontStyle: 'bold',
                                fill: ['#ffffff', '#ededed'],
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },

                        {
                            "id": "fg_intro_freespintext",
                            "name": "fg_intro_freespintext_desktop",
                            "type": "Text",
                            "x": 955,
                            "y": 750,
                            "visible": true,
                            "layout": false,
                            "uimode": "desktop",
                            "text": "fsStartMessage",
                            "width": 1800,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 70,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },




                        {
                            "name": "introBg_mobile",
                            "image": "introBG",
                            "type": "Image",
                            "class": "",
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "interactive": false,
                            "buttonMode": false,
                            "group": "Intro",
                            "width": 1078,
                            "height": 921,
                            "anchor": [0.5, 0.5],
                            "x": 960,
                            "y": 540,
                        },
                        {
                            "id": "fg_intro_Congratulation",
                            "name": "fg_intro_Congratulation_mobile",
                            "type": "Text",
                            "x": 940,
                            "y": 340,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "text": "congrats",
                            "width": 2440,
                            "height": 600,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 110,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },


                        {
                            "id": "fg_intro_count",
                            "name": "fg_intro_count_mobile",
                            "type": "Text",
                            "x": 955,
                            "y": 610,
                            "visible": true,
                            "layout": true,
                            "uimode": "mobile",
                            "text": "",
                            "width": 1200,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 200,
                                fontStyle: 'bold',
                                fill: ['#ffffff', '#ededed'],
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },

                        {
                            "id": "fg_intro_freespintext",
                            "name": "fg_intro_freespintext_mobile",
                            "type": "Text",
                            "x": 955,
                            "y": 750,
                            "visible": true,
                            "text": "fsStartMessage",
                            "layout": true,
                            "uimode": "mobile",
                            "width": 1800,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 70,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },
                        {
                            "id": "fg_intro_lockedReel",
                            "name": "fg_intro_lockedReel",
                            "type": "Text",
                            "x": 965,
                            "y": 750,
                            "visible": false,
                            "layout": false,
                            "uimode": "desktop",
                            "text": "buyFeature",
                            "width": 1200,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Dalelands',
                                fontSize: 60,
                                fontStyle: 'bold',
                                fill: ['#f4fa4b', '#fa8c16'],
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },


                        {
                            "id": "fg_intro_lockedReel",
                            "name": "fg_intro_lockedReel",
                            "type": "Text",
                            "x": 560,
                            "y": 1110,
                            "visible": false,
                            "layout": false,
                            "uimode": "mobile",
                            "text": "buyFeature",
                            "width": 1200,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'Dalelands',
                                fontSize: 55,
                                fontStyle: 'bold',
                                fill: ['#f4fa4b', '#fa8c16'],
                                dropShadow: true,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },
                        /*   {
                              "id": "fg_intro_clickAnywhereText",
                              "name": "fg_intro_clickAnywhereText_mobile",
                              "type": "Text",
                              "x": 955,
                              "y": 830,
                              "visible": true,
                              "layout": true,
                              "uimode": "mobile",
                              "text": "introtext_5",
                              "width": 1000,
                              "height": 200,
                              "scaleToFit": true,
                              "anchor": [0.5, 0.5],
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 32,
                                  fontStyle: 'bold',
                                  fill: ['#ffffff'],
                                  dropShadow: true,
                                  dropShadowColor: '#000000',
                                  dropShadowBlur: 2,
                                  dropShadowAngle: Math.PI / 2,
                                  dropShadowDistance: 6,
  
  
                              }
                          }, */
                        {
                            "id": "fg_intro_you",
                            "name": "fg_intro_you_desktop",
                            "type": "Text",
                            "x": 955,
                            "y": 470,
                            "visible": true,
                            "text": "youve",
                            "layout": false,
                            "uimode": "desktop",
                            "width": 1200,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 70,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                letterSpacing: 3,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,


                            }
                        },
                        {
                            "id": "fg_intro_you",
                            "name": "fg_intro_you_mobile",
                            "type": "Text",
                            "x": 955,
                            "y": 470,
                            "visible": true,
                            "text": "youve",
                            "uimode": "mobile",
                            "layout": true,
                            "width": 1200,
                            "height": 200,
                            "scaleToFit": true,
                            "anchor": [0.5, 0.5],
                            "textStyle": {
                                fontFamily: 'impact',
                                fontSize: 70,
                                fontStyle: 'bold',
                                fill: ['#efe457', '#feae31'],
                                dropShadow: true,
                                letterSpacing: 3,
                                dropShadowColor: '#000000',
                                dropShadowBlur: 2,
                                dropShadowAngle: Math.PI / 2,
                                dropShadowDistance: 6,

                            }
                        },

                        {
                            "id": "btn_continue_intro",
                            "name": "btn_continue_intro",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,

                            "group": "Intro",
                            "x": 947,
                            "y": 910,
                            "width": 273,
                            "height": 73,
                            "text": "continueIntroText",
                            "textStyle": {
                                fontFamily: 'Oswald-Regular',
                                fontSize: 24,
                                fontStyle: 'normal',
                                fill: ['#000000'],

                            },
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'intro_continue_up.png',
                                out: 'intro_continue_up.png',
                                down: 'intro_continue_up.png',
                                disable: 'intro_continue_up.png',
                                enable: 'intro_continue_up.png',
                                hover: 'intro_continue_over.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },

                        /*  {
                             "name": "introPanelSkipGraphic",
                             "type": "Graphic",
                             "shape": "rectangle",
                             "visible": true,
                             "alpha": 1,
                             "group": "Intro",
                             "layout": true,
                             "color": "0x000000",
                             "x": 427,
                             "y": 1264,
                             "width": 273,
                             "height": 73,
                         },
  */

                        {
                            "name": "introPanelSkipGraphic",
                            "type": "Graphic",
                            "shape": "rectangle",
                            "visible": true,
                            "layout": true,
                            "alpha": 0.0001,
                            "group": "Intro",
                            "color": "0xC5472C",
                            "x": 819,
                            "y": 928,
                            "width": 273,
                            "height": 73,
                        },

                        /*  {
                              "id": "Button_1_desktop",
                              "name": "btn_introBanner_mobile",
                              "type": objectTypes.Sprite,
                              "interactive": true,
                              "layout": true,
                              "uimode": "mobile",
                              "group": "Intro",
                              "x": 900,
                              "y": 900,
                              "height": 194,
                              "width": 495,
                              "text": "start_btn",
                              "textStyle": {
                                  fontFamily: 'Arial',
                                  fontSize: 100,
                                  fontStyle: 'normal',
                                  fontWeight: 'bold',
                                  fill: ['#ffffff'],
                                  dropShadow: true,
                                  dropShadowColor: '#000000',
                                  dropShadowBlur: 2,
                                  dropShadowAngle: Math.PI / 2,
                                  dropShadowDistance: 10,
  
                              },
                              "anchor": [0.5, 0.5],
                              "visible": false,
                              "buttonMode": true,
                              "buttonState": {
                                  up: 'post_intro_start_up.png',
                                  out: 'post_intro_start_up.png',
                                  down: 'post_intro_start_down.png',
                                  disable: 'post_intro_start_disable.png',
                                  enable: 'post_intro_start_up.png',
                                  hover: 'post_intro_start_over.png'
                              },
                              "hitareaVisible": false,
                              "shapeVisible": false,
                              "shape": {}
                          },*/

                    ]
                }
            ]

        },
    ]
};